import { render, staticRenderFns } from "./brick.vue?vue&type=template&id=f50e81b2&"
import script from "./brick.vue?vue&type=script&lang=js&"
export * from "./brick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports